import { Button, Card, Image, message, Modal } from "antd";
import React, { useState } from "react";
import {
  Pending,
  ReadyForReview,
  Rejected,
  Verified,
} from "../../../components/components/StatusIndicators";
import { formatDateDDMMYYYY } from "../../../utils/commonFunctions";
import {
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import useAxios from "../../../hooks/useAxios";
import useGetFile from "../../../hooks/useGetFile";
import useAuthUserToken from "../../../hooks/useAuthUserToken";
import RejectModal from "../../Candidate/components/RejectModal";
import EditedTag from "../Components/EditedTag";
import AIRemarks from "../Components/AIRemarks";

const AadharCardSection = ({
  aadharDetails,
  candidateDetails,
  s3Files,
  setLoading,
  getCandidateDetails,
  getAadharAndPanDetails,
  aiRemarks,
  canAcceptReject
}) => {
  const api = useAxios();
  const { userToken } = useAuthUserToken();
  const { getImage } = useGetFile(userToken);
  const [aadharModal, setAadharModal] = useState(false);
  const [viewAadharPhoto, setViewAadharPhoto] = useState(false);
  const [aadharImage, setAadharImage] = useState("");
  const [aadharImgReject, setAadharImgReject] = useState(false);
  const [aadharRejectModal, setAadharRejectModal] = useState(false);
  const [imgAadharRejectReason, setImgAadharRejectReason] = useState("");
  const [aadharRejectReason, setAadharRejectReason] = useState("");

  const toggleAadharReject = () => setAadharRejectModal(!aadharRejectModal);

  const acceptRejectAadharImage = async (status, reason) => {
    setLoading(true);
    try {
      const data = await api.put(
        `/candidate/aadharCardImageStatus/${candidateDetails?._id}`,
        {
          Status: status,
          ...(reason !== null && { aadharRejection: reason }),
        },
        { tokenType: "user" }
      );
      console.log(data.data);
      setImgAadharRejectReason("");
      if (!status) {
        setAadharImgReject(!aadharImgReject);
      }
      await getCandidateDetails();
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const acceptRejectAadhar = async (_id, status) => {
    setLoading(true);
    try {
      await api.put(
        `/candidateDocuments/aadharPanStatus/${_id}`,
        {
          Status: status,
          rejectionReason: aadharRejectReason || null,
        },
        { tokenType: "user" }
      );
      getAadharAndPanDetails();
      setAadharRejectReason("");
      if (!status) {
        setAadharRejectModal(false);
      }
      setAadharModal(false);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error.message);
    } finally {
      setLoading(false);
    }
  };

  const IS_REJECTED_NUMBER =
    aadharDetails?.documentStatus !== null &&
    aadharDetails?.documentStatus === false &&
    aadharDetails?.isFilledStatus === false;

  const IS_REJECTED_PHOTO =
    candidateDetails?.aadharStatus !== null &&
    candidateDetails?.aadharStatus === false &&
    candidateDetails?.aadharCardImageFilledStatus === false;

  const IS_VERIFIED_PHOTO = candidateDetails?.aadharStatus;
  const IS_VERIFIED_NUMBER = aadharDetails?.documentStatus;

  const OCR_AADHAR = (
    candidateDetails?.aadharCardImage?.[0]?.OCRData?.response?.aadhaar_number ||
    ""
  )?.trim();
  const ENTER_AADHAR = (candidateDetails?.aadharCardNo || "")?.trim();

  const IS_EDITED = OCR_AADHAR !== ENTER_AADHAR;

  return (
    <>
      <Card
        className="border bg-white col-md-12 mb-2"
        title={`Aadhar Card Verification`}
      >
        <div className="d-flex gap-1">
          <div
            style={{
              ...(IS_REJECTED_PHOTO ? { border: "1px solid red" } : {}),
              // ...(IS_VERIFIED_PHOTO ? { border: "1px solid #00AC1A" } : {}),
              position: "relative",
              minWidth: "280px",
            }}
            className="card p-2"
          >
            <div className="d-flex flex-column justify-content-between h-100">
              <div className="flex justify-between">
                <strong>Aadhar Card Image : </strong>
                {
                  candidateDetails?.aadharCardImage?.length !== 0 &&
                  <AIRemarks aiRemarks={aiRemarks} docType={"Aadhar_Card"}/>
                }
              </div>
              <div className="gap-1 d-flex flex-row justify-content-between">
                <div className="d-flex">
                  {canAcceptReject && (
                    <>
                      <Button
                        disabled={
                          (candidateDetails?.aadharStatus &&
                            candidateDetails?.isEmpTempIdCreated) ||
                          candidateDetails?.aadharCardImage?.length === 0
                        }
                        title="accept"
                        shape="circle"
                        type="success"
                        size="small"
                        icon={<CheckOutlined />}
                        className="mr-1"
                        onClick={(e) => acceptRejectAadharImage(true)}
                      ></Button>
                      <Button
                        disabled={
                          (candidateDetails?.aadharStatus &&
                            candidateDetails?.isEmpTempIdCreated) ||
                          candidateDetails?.aadharCardImage?.length === 0
                        }
                        title="reject"
                        shape="circle"
                        type="danger"
                        size="small"
                        icon={<CloseOutlined />}
                        className="mr-1"
                        onClick={() => {
                          setAadharImgReject(!aadharImgReject);
                        }}
                      ></Button>
                    </>
                  )}
                  <Button
                    title="view"
                    shape="circle"
                    type=""
                    size="small"
                    disabled={candidateDetails?.aadharCardImage?.length === 0}
                    icon={<EyeOutlined />}
                    onClick={async () => {
                      const img = await getImage(
                        candidateDetails?.aadharCardImage[0]?.path
                      );
                      setAadharImage(img);
                      setViewAadharPhoto(true);
                    }}
                    className="mr-1"
                  ></Button>
                </div>
                <div className="">
                  {candidateDetails?.aadharCardImageFilledStatus === false &&
                  candidateDetails?.aadharStatus === null ? (
                    <Pending />
                  ) : (
                    <>
                      {(candidateDetails?.aadharStatus === null ||
                        candidateDetails?.aadharStatus === false) &&
                      candidateDetails?.aadharCardImageFilledStatus === true ? (
                        <ReadyForReview />
                      ) : (
                        <>
                          {candidateDetails?.aadharStatus ? (
                            <Verified />
                          ) : (
                            <>
                              <Rejected />
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            {IS_REJECTED_PHOTO && (
              <div
                className="d-flex gap-2 text-danger font-weight-bold"
                style={{ position: "absolute", bottom: -20, right: 0 }}
              >
                Reason : {candidateDetails?.aadharRejection}
              </div>
            )}
          </div>
          <div
            style={{
              ...(IS_REJECTED_NUMBER ? { border: "1px solid red" } : {}),
              // ...(IS_VERIFIED_NUMBER ? { border: "1px solid #00AC1A" } : {}),
              position: "relative",
              flex: "1 1",
            }}
            className="card p-2 d-flex"
          >
            <div className="flex justify-between">
              <div className="flex gap-[5px]">
                <div className="flex flex-row card p-2 gap-[5px]">
                  <strong>Name:</strong>
                  {aadharDetails?.aadharVerificationDetails?.data?.full_name ? (
                    aadharDetails?.aadharVerificationDetails?.data?.full_name
                  ) : (
                    <span>Not Filled</span>
                  )}
                </div>
                <div className="d-flex flex-row card p-2 relative gap-[5px]">
                  <strong>Aadhar Number:</strong>
                  {candidateDetails?.aadharCardNo !== "" ? (
                    <>
                      {candidateDetails?.aadharCardNo}
                      {IS_EDITED && (
                        <span
                          style={{
                            fontSize: 12,
                            backgroundColor: "grey",
                          }}
                          className="text-white px-1 rounded"
                        >
                          Edited
                        </span>
                      )}
                    </>
                  ) : (
                    <span>Not Filled</span>
                  )}
                </div>
                <div className="flex flex-row card p-2 gap-[5px]">
                  <strong>Date of Birth:</strong>
                  {aadharDetails?.aadharVerificationDetails?.data?.dob ? (
                    aadharDetails?.aadharVerificationDetails?.data?.dob
                  ) : (
                    <span>Not Filled</span>
                  )}
                </div>
              </div>
              {/* <AIRemarks aiRemarks={aiRemarks} /> */}
            </div>
            <div className="flex flex-column">
              <div className="pt-2 d-flex justify-content-between flex-row">
                <div>
                  <button
                    className="btn-sm btn-primary"
                    onClick={() => setAadharModal(!aadharModal)}
                  >
                    View More{" "}
                  </button>
                </div>
                <div className="d-flex align-items-center">
                  {aadharDetails?.documentStatus === undefined ||
                  (aadharDetails?.isFilledStatus === false &&
                    aadharDetails?.documentStatus === null) ? (
                    <Pending />
                  ) : (
                    <>
                      {(aadharDetails?.documentStatus === null ||
                        aadharDetails?.documentStatus === false) &&
                      aadharDetails.isFilledStatus === true ? (
                        <ReadyForReview />
                      ) : (
                        <>
                          {aadharDetails?.documentStatus ? (
                            <Verified />
                          ) : (
                            <Rejected />
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            {IS_REJECTED_NUMBER && (
              <div
                className="d-flex gap-2 text-danger font-weight-bold"
                style={{ position: "absolute", bottom: -20, right: 0 }}
              >
                Reason : {aadharDetails?.rejectionReason}
              </div>
            )}
          </div>
        </div>
      </Card>
      <Modal
        centered
        open={aadharModal}
        onCancel={() => setAadharModal(!aadharModal)}
        width={800}
        footer={
          <div className="d-flex gap-1 justify-content-center mb-2">
            {canAcceptReject && (
              <>
                <button
                  className={`btn btn-sm ${
                    aadharDetails?.documentStatus === undefined ||
                    aadharDetails?.documentStatus === true ||
                    aadharDetails?.aadharVerificationDetails?.status_code === 501
                      ? "btn-secondary"
                      : "btn-primary"
                  }`}
                  disabled={
                    aadharDetails?.documentStatus === undefined ||
                    aadharDetails?.documentStatus === true ||
                    aadharDetails?.aadharVerificationDetails?.status_code === 501
                  }
                  onClick={(e) => acceptRejectAadhar(aadharDetails._id, true, null)}
                >
                  Accept
                </button>
                <button
                  className={`btn btn-sm ${
                    aadharDetails?.documentStatus === undefined ||
                    aadharDetails?.documentStatus === true ||
                    aadharDetails?.aadharVerificationDetails?.status_code === 501
                      ? "btn-secondary"
                      : "btn-danger"
                  }`}
                  disabled={
                    aadharDetails?.documentStatus === undefined ||
                    aadharDetails?.documentStatus === true ||
                    aadharDetails?.aadharVerificationDetails?.status_code === 501
                  }
                  onClick={(e) => {
                    console.log("object");
                    toggleAadharReject();
                  }}
                >
                  Reject
                </button>
              </>
            )}
          </div>
        }
        title="Aadhar Card Comparison"
      >
        <div className="table-responsive">
          <table id="table-datatable" className="table bg-white border">
            <tbody>
              <tr className="table-column-head">
                <th style={{ borderRight: "1px solid #e3e6f0" }}>
                  Form Details
                </th>
                <th>Aadhar Details</th>
              </tr>
              <tr className="table-column-head">
                <td valign="top" style={{ borderRight: "1px solid #e3e6f0" }}>
                  <div className="d-flex flex-column" style={{ gap: "1rem" }}>
                    <div
                      className={`verify__photo ${
                        candidateDetails?.candidatePhoto?.length !== 0
                          ? ""
                          : "verify__photo_active"
                      }`}
                    >
                      {candidateDetails?.candidatePhoto?.length !== 0 ? (
                        <>
                          {candidateDetails?.candidatePhoto && (
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={s3Files?.candidatePhoto}
                              alt="avatar"
                            />
                          )}
                        </>
                      ) : (
                        <img
                          src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
                          style={{ width: "100%", height: "100%" }}
                          alt="Avatar"
                        />
                      )}
                    </div>
                    <div>
                      Name : <strong>{candidateDetails?.name}</strong>
                    </div>
                    <div>
                      DOB :{" "}
                      <strong>
                        {formatDateDDMMYYYY(new Date(candidateDetails?.DOB))}
                      </strong>
                    </div>
                    <div>
                      Mobile No. : <strong>{candidateDetails?.mobileNo}</strong>
                    </div>
                  </div>
                </td>
                <td valign="top">
                  <div className="d-flex flex-column" style={{ gap: "1rem" }}>
                    <div
                      className={`verify__photo ${
                        aadharDetails?.aadharVerificationDetails?.data
                          ?.profile_image
                          ? ""
                          : "verify__photo_active"
                      }`}
                    >
                      <img
                        className="img"
                        src={
                          "data:image/png;base64," +
                          aadharDetails?.aadharVerificationDetails?.data
                            ?.profile_image
                        }
                        alt=""
                      />
                    </div>
                    <div>
                      Name :{" "}
                      <strong>
                        {aadharDetails?.aadharVerificationDetails?.data
                          ?.full_name ? (
                          aadharDetails?.aadharVerificationDetails?.data
                            ?.full_name
                        ) : (
                          <span>Not Filled</span>
                        )}
                      </strong>
                    </div>
                    <div>
                      DOB :{" "}
                      <strong>
                        {aadharDetails?.aadharVerificationDetails?.data?.dob ? (
                          formatDateDDMMYYYY(
                            aadharDetails?.aadharVerificationDetails?.data?.dob
                          )
                        ) : (
                          <span>Not Filled</span>
                        )}{" "}
                      </strong>
                    </div>
                    {/* <div>
                            Mobile No. :{" "}
                            <strong>
                              {aadharDetails?.aadharVerificationDetails?.data
                                ?.mobile_verified !== undefined ? (
                                aadharDetails?.aadharVerificationDetails?.data
                                  ?.mobile_verified ? (
                                  "Matched"
                                ) : (
                                  "UnMatched"
                                )
                              ) : (
                                <span>Not Filled</span>
                              )}
                            </strong>
                          </div> */}
                    <div>
                      Care Of :{" "}
                      <strong>
                        {aadharDetails?.aadharVerificationDetails?.data
                          ?.care_of ? (
                          aadharDetails?.aadharVerificationDetails?.data
                            ?.care_of
                        ) : (
                          <span>Not Filled</span>
                        )}{" "}
                      </strong>
                    </div>
                  </div>
                </td>
              </tr>
              {/* {aadharDetails?.aadharVerificationDetails?.data
                      ?.mobile_verified === false && (
                      <tr>
                        <td colSpan={2}>
                          <p style={{ color: "red" }}>
                            "Candidate registred Mobile number can't match with Aadhar
                            linked Mobile number"
                          </p>
                        </td>
                      </tr>
                    )} */}
            </tbody>
          </table>
        </div>
      </Modal>
      <Modal
        centered
        open={viewAadharPhoto}
        onOk={(e) => setViewAadharPhoto(!viewAadharPhoto)}
        onCancel={(e) => setViewAadharPhoto(!viewAadharPhoto)}
        width={800}
        title="Aadhar Comparison"
        footer={null}
      >
        <div>
          <h6>FILLED BY CANDIDATE</h6>
          <div
            className={`verify__photo ${
              candidateDetails?.candidatePhoto?.length !== 0
                ? ""
                : "verify__photo_active"
            }`}
          >
            {candidateDetails?.candidatePhoto?.length !== 0 ? (
              // <img
              //   src={url(imageLink)}
              //   style={{ width: "100%", height: "100%" }}
              //   alt="Avatar"
              // />
              candidateDetails?.candidatePhoto && (
                <img
                  alt="passport_photo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={s3Files?.candidatePhoto}
                />
              )
            ) : (
              <img
                src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
                style={{ width: "100%", height: "100%" }}
                alt="passport_photo"
              />
            )}
          </div>
          <div className="d-flex mt-2" style={{ gap: "1rem" }}>
            <div>
              Name : <strong>{candidateDetails?.name}</strong>
            </div>
            <div>
              DOB :{" "}
              <strong>
                {formatDateDDMMYYYY(new Date(candidateDetails?.DOB))}
              </strong>
            </div>
            <div>
              Mobile No. : <strong>{candidateDetails?.mobileNo}</strong>
            </div>
            <div>
              Aadhar No. :{" "}
              <strong>
                {candidateDetails?.aadharCardNo === ""
                  ? "Not filled"
                  : candidateDetails?.aadharCardNo}
              </strong>
            </div>
          </div>
          <h6 className="mt-3">Aadhar Image</h6>
          <div
            style={{
              width: "100%",
              height: "500px",
              overflowY: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="mt-3"
          >
            {candidateDetails?.aadharCardImage.length !== 0 ? (
              <>
                {/* {candidateDetails?.aadharCardImage && (
                        <img
                          style={{objectFit:'contain'}}
                          src={
                            documentType === "S3" && BASE.storageType
                              ? s3Files?.aadharCardImage
                              : url("/uploads/") +
                                candidateDetails?.aadharCardImage[0]?.filename
                          }
                          alt="aadharcard"
                        />
                      )} */}
                <Image src={aadharImage} />
              </>
            ) : (
              <>
                <h3>Image not uploaded yet.</h3>
              </>
            )}
          </div>
        </div>
      </Modal>
      <RejectModal
        open={aadharImgReject}
        closeHandler={setAadharImgReject}
        value={imgAadharRejectReason}
        setValue={setImgAadharRejectReason}
        onSubmit={() => acceptRejectAadharImage(false, imgAadharRejectReason)}
      />
      <RejectModal
        open={aadharRejectModal}
        closeHandler={setAadharRejectModal}
        value={aadharRejectReason}
        setValue={setAadharRejectReason}
        onSubmit={() => acceptRejectAadhar(aadharDetails._id, false)}
      />
    </>
  );
};

export default AadharCardSection;
